import { TenantConfiguration } from '@tom-ui/admin'
import { SingleLocationCodeAutoComplete } from '@tom-ui/planning'
import { observer } from 'mobx-react-lite'

export const TenantConfigurationPage = observer(() => (
  <TenantConfiguration autocomplete={SingleLocationCodeAutoComplete} />
))
